import React, { useState, useEffect } from 'react';
import MendList from '../mend-comp/mendList';
import './mends.css';



const Mends = () => {

  const [mendData, setMendData] = useState([]);

   useEffect(() => {
        const mendData = async () => {
          try {
            const response = await fetch(process.env.REACT_APP_BACKEND_URL + '/mend');
            const responseData = await response.json();
            setMendData(responseData.mend);

          } catch (err) {
            console.log(err.message)
          }
        }
        mendData()
      }, []);
   
    return (
        <main className='mends-container'>
            <MendList mends={mendData}/>
        </main>
    )
}
export default Mends;
